export default[
    {
        "type": "button_main",
        "key": "retry",
        "title": "重试",
        "area": "page_header,table_row"
    },
    {
        "type": "button_main",
        "key": "return",
        "title": "回退",
        "area": "page_header,table_row"
    },
    {
        "type": "button_main",
        "key": "orderback",
        "title": "订单追溯",
        "area": "page_header,table_row"
    }
];